import { Component, OnInit } from "@angular/core";
import {
  faPlus,
  faSave,
  faTrash,
  faPrint,
} from "@fortawesome/free-solid-svg-icons";
import { FormField } from "src/app/interfaces/form-field.model";
import { CoeBidStaffService } from "src/app/services/autopac/coe-bid-staff.service";

@Component({
  selector: "app-coe-bid-staff",
  templateUrl: "./coe-bid-staff.component.html",
  styleUrls: ["./coe-bid-staff.component.css"],
})
export class CoeBidStaffComponent implements OnInit {
  faPlus = faPlus;
  faSave = faSave;
  faTrash = faTrash;
  faPrint = faPrint;

  searchCriteria!: FormField[];

  constructor(private coeBidStaffService: CoeBidStaffService) {}

  updateFields(event: any) {
    this.searchCriteria = event.fields;
  }

  ngOnInit() {
    this.searchCriteria = [
      {
        type: "search",
        id: "biddersNRIC",
        label: "Bidder's NRIC",
        required: true,
        searchEvent: true,
        isAuto: true,
      },
      {
        type: "text",
        id: "biddersName",
        label: "Bidder's name",
        required: true,
      },
      {
        type: "text",
        id: "salesConsultant",
        label: "Sales consultant / department",
        required: true,
      },
      {
        type: "select",
        id: "selectFormat",
        label: "Select format",
        options: [
          { display: "EXCEL", value: "EXCEL" },
          { display: "PDF", value: "PDF" },
          { display: "BOTH", value: "BOTH" },
        ],
        value: "PDF"
      },
    ];
  }

  searchData(event: any) {
    const bidderField = this.searchCriteria.find(field => field.id === 'biddersNRIC');
    const bidderIc = bidderField?.value?.trim(); 
  
    if (!bidderIc) {
      alert("Please enter a Bidder's NRIC.");
      return;
    }
  
    this.coeBidStaffService.getByIc(bidderIc).subscribe(
      (response) => {
        if (response?.body) {
          const { UserName, Dept } = response.body;
  
          this.searchCriteria.forEach(field => {
            if (field.id === 'biddersName') {
              field.value = UserName;
            } else if (field.id === 'salesConsultant') {
              field.value = Dept;
            }
          });
        }
      },
      (error) => {
        console.error("Error fetching data:", error);
      }
    );
  }  

  addRecord(): void {
    const bidderIcField = this.searchCriteria.find(field => field.id === 'biddersNRIC');
    const nameField = this.searchCriteria.find(field => field.id === 'biddersName');
    const deptField = this.searchCriteria.find(field => field.id === 'salesConsultant');
  
    if (!bidderIcField?.value || !nameField?.value || !deptField?.value) {
      alert("Please fill in all required fields before adding a record.");
      return;
    }
  
    const payload = {
      CustomerIc: bidderIcField.value.trim(),
      UserName: nameField.value.trim(),
      Dept: deptField.value.trim()
    };
  
    this.coeBidStaffService.addRecord(payload).subscribe(response => {
      alert("Record added successfully!");
    });
  }
  
  updateRecord(): void {
    const bidderIcField = this.searchCriteria.find(field => field.id === 'biddersNRIC');
    const nameField = this.searchCriteria.find(field => field.id === 'biddersName');
    const deptField = this.searchCriteria.find(field => field.id === 'salesConsultant');
  
    if (!bidderIcField?.value || !nameField?.value || !deptField?.value) {
      alert("Please fill in all required fields before updating the record.");
      return;
    }
  
    const payload = {
      CustomerIc: bidderIcField.value.trim(),
      UserName: nameField.value.trim(),
      Dept: deptField.value.trim()
    };
  
    this.coeBidStaffService.updateRecord(payload).subscribe(response => {
      alert("Record updated successfully!");
    });
  }
  
  delete(): void {
    const bidderIcField = this.searchCriteria.find(field => field.id === 'biddersNRIC');
    const bidderIc = bidderIcField?.value?.trim();
  
    if (!bidderIc) {
      alert("Please enter a Bidder's NRIC.");
      return;
    }
  
    this.coeBidStaffService.delete(bidderIc).subscribe(response => {
      alert("Record deleted successfully!");
      this.searchCriteria.forEach(field => field.value = "");
    });
  }
  
  getCOEBidStaffReport(): void {
    this.coeBidStaffService.getCOEBidStaffReport().subscribe(response => {
      alert("Report generated successfully!");
    });
  }
  
}
